/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon, FlexContainer, ExtendedTooltip } from "@nordcloud/gnui";
import { SpendTreeItem } from "~/views/businessContexts/OrganizationUnit/Lists";
import { LinkButton } from "../styled";
import { OrganizationUnitChildTableColumns } from "./OrganizationUnitStructure";

type Row = {
  original: SpendTreeItem;
  depth: number;
  isExpanded: boolean;
  subRows: SpendTreeItem[];
};

type Data = {
  row: Row;
  data: SpendTreeItem[];
};

type Props = {
  structureId: string;
  open: () => void;
  setOrgUnitId: (id: string) => void;
  setOrgUnitName: (name: string) => void;
  environmentId?: string;
};

export const OrganizationUnitsTableColumns = ({
  structureId,
  open,
  setOrgUnitId,
  setOrgUnitName,
}: Props) => {
  const tooltipIndex = 10_000;

  const onClickAttach = (id: string, name: string) => {
    open();
    setOrgUnitId(id);
    setOrgUnitName(name);
  };

  return [
    ...OrganizationUnitChildTableColumns(structureId),
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      width: "3rem",
      hasLeftBorder: false,
      Cell: ({ row }: Data) => {
        return (
          <FlexContainer justifyContent="flex-end">
            <ExtendedTooltip caption="Attach to the OU" zIndex={tooltipIndex}>
              <LinkButton
                onClick={() =>
                  onClickAttach(row.original.nid, row.original.name)
                }
              >
                <SVGIcon name="link" size="sm" />
              </LinkButton>
            </ExtendedTooltip>
          </FlexContainer>
        );
      },
    },
  ];
};
